class Preloader {
    constructor(element) {
        this.element = element;
    }

    showPreloader() {
        $(this.element).addClass('preloader');
    }

    hidePreloader() {
        $(this.element).removeClass('preloader');
    }

    togglePreloader() {
        $(this.element).toggleClass('preloader');
    }
}
